import React from 'react';
import { LocationSearchMap } from "../common/LocationSearchMap";
import { TrailCategory } from '../../types/trail';

interface MapSectionProps {
    category: TrailCategory;
    dogGpxData: any;
    userGpxData: any;
    locationCoordinate: [number, number];
    previewDogPath: [number, number][] | null;
    previewUserPath: [number, number][] | null;
    setLocation: (location: string) => void;
    setLocationCoordinate: (coords: [number, number]) => void;
    location: string;
}

export function MapSection({
    category,
    dogGpxData,
    userGpxData,
    locationCoordinate,
    previewDogPath,
    previewUserPath,
    setLocation,
    setLocationCoordinate,
    location,
}: MapSectionProps) {
    return (
        <div className="space-y-4">
            <h3 className="text-lg text-blue-900">Localisation</h3>
            <div className="space-y-2">
              <p className="text-sm text-muted-foreground">
                Recherchez un lieu ou cliquez sur la carte pour définir la localisation.
                {(dogGpxData || userGpxData) && " Les traces GPX sont affichées en bleu (chien) et orange (victime/personne)."}
              </p>
              <LocationSearchMap
                center={
                  (category === "mantrailing" ? dogGpxData?.center : userGpxData?.center) || 
                  (category === "mantrailing" ? userGpxData?.center : dogGpxData?.center) || 
                  locationCoordinate
                }
                zoom={dogGpxData || userGpxData ? 15 : 12}
                dogPath={previewDogPath || dogGpxData?.path}
                victimPath={previewUserPath || userGpxData?.path}
                onLocationChange={(locationText, coordinates) => {
                  setLocation(locationText);
                  setLocationCoordinate(coordinates);
                }}
                locationValue={location}
              />
            </div>
        </div>
    );
}
